/* Library */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import commonUtil from '../../../../../utils/commonUtil';

// import components
import ConfirmationModal from './confirmationModal';
import Warning from '../../../../../components/Warning';
import TextInput from '../../../../../components/ZUILib/TextInput';
import CalenderSample from '../../../../../components/ZUILib/CalenderSample';
import SelectionTab from '../../../../../components/ZUILib/SelectionTab';
import CheckBox from '../../../../../components/ZUILib/CheckBox';
// import ImageLink from '../../../../../components/ZUILib/ImageLink';
import ApplyCSS from '../../../../../components/ApplyCSS';
import InputButton from '../../../../../components/ZUILib/InputButton';
import Link from '../../../../../components/ZUILib/Link';
import * as defaultConst from '../../../../../utils/clientConstant';

// Actions
import * as editOwnerActions from './actions';

const pageName = 'EditAdminInfo';
const channel = commonUtil.getChannel();
const { updateOwnerDetails, addCoOwnerDetails, isCoOwnerEligible, sendEmailToCoOwner, getCoOwnerProfileId } = editOwnerActions;
const innerWidth = typeof window !== 'undefined' && window.innerWidth;
const errorObject = require('../../../../../utils/errors/LP_GR_error.json');

// const { strategy } = require('./../strategy');


@connect(store => ({
  lables: store.labels.data,
}))

class EditAdminCelebratedInfo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      permission: false,
      dateOfBirth: '',
      // renderData: true,
    };
    this.checkBoxSelected = '';
    this.adminDetails = {
      dateOfBirth: '',
      celebrityLabel: '',
      firstName: '',
      lastName: '',
      motherName: '',
      nickName: '',
      phone: '',
      email: '',
      title: '',
      displayEmailField: 'true',
    };
    if (this.props.celebrityInfo) {
      this.adminDetails = JSON.parse(JSON.stringify(this.props.celebrityInfo));
    }
    this.warningMessage = null;
    this.editOwner = '';
    this.selectedEventConfiguration = '';
    this.isValueAvailable = this.isValueAvailable.bind(true);
    this.formData = {
      owner: {
        ownerfirstName: '',
        ownerMotherName: '',
        ownerlastName: '',
        ownerDateofbirth: '',
        ownerHasPermission: '',
        ownerEmail: '',
        ownerTitle: '',
        ownerLabel: '',
        ownerPhone: '',
        ownerId: '',
        ownerNickName: '',
      },
    };
    this.ownerEmailId = this.props.userEventDetails && this.props.userEventDetails.eventDetailsInfo && this.props.userEventDetails.eventDetailsInfo.celebrityInfo
      && this.props.userEventDetails.eventDetailsInfo.celebrityInfo[0] && this.props.userEventDetails.eventDetailsInfo.celebrityInfo[0].email ?
      this.props.userEventDetails.eventDetailsInfo.celebrityInfo[0].email : '';
  }
  hideCelebityEditingSection = () => {
    this.setState({
      date: '',
      updateCelebrity: true,
    });
    this.props.hideCelebityEditingSection();
  }
  setDateOfBirth = (date) => {
    this.adminDetails.dateOfBirth = date;
    this.setState({
      date,
    });
  }
  componentWillReceiveProps(nextProps) {
    this.adminDetails = JSON.parse(JSON.stringify(nextProps.celebrityInfo));
    if (nextProps.isAddingNewCoOwnerMode) {
      nextProps.showCelebityEditingSection();
    }
    // if (nextProps.celebrityInfo.email && nextProps.celebrityInfo.email !== '' && nextProps.celebrityInfo && nextProps.celebrityInfo.iscoOwner === 'true') {
    //   this.checkBoxSelected = true;
    //   this.setState({
    //     permission: true,
    //   });
    // } else if (nextProps.celebrityInfo.email && nextProps.celebrityInfo.email !== '' && nextProps.celebrityInfo && nextProps.celebrityInfo.iscoOwner === 'false') {
    //   this.checkBoxSelected = false;
    //   this.setState({
    //     permission: true,
    //   });
    // } else {
    //   this.checkBoxSelected = false;
    //   this.setState({
    //     permission: false,
    //   });
    // }
  }
  cancelEditingAndAdding = () => {
    this.props.handleCancelEditingAndAdding();
  }
  sentenceCase = (str) => {
    if (!str) { return false; }
    const newStr = str.toString();
    return newStr.replace(/\w\S*/g, txt => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase());
  }
  // isPhoneNumberValidInLength = num => num.length === 10
  isValueAvailable = (str) => {
    if (str && str.trim()) {
      return true;
    }
    return false;
  }
  componentDidMount() {
    if (this.props.isAddingNewCoOwnerMode) {
      this.props.showCelebityEditingSection();
    }
    if (this.selectedDate && this.props.celebrityInfo && this.props.celebrityInfo.dateOfBirth) {
      this.selectedDate.setDate(this.props.celebrityInfo.dateOfBirth);
    }
    
    // let adminDetails = '';
    // if (this.props.celebrityInfo) {
    //   adminDetails = this.props.celebrityInfo;
    // }
    // if (adminDetails.email && document.querySelector('.mailInput')) {
    //   document.querySelector('.mailInput').setAttribute('style', 'display:block');
    // } else if (!adminDetails.email && document.querySelector('.mailInput')) {
    //   document.querySelector('.mailInput').setAttribute('style', 'display:none');
    // }

    // // for coOwner service call fetching owner Label
    // if (document.querySelector('#lableArea')) {
    //   const temp = document.querySelector('#lableArea').innerText;
    //   this.formData.owner.ownerLabel = temp;
    // } else {
    //   this.formData.owner.ownerLabel = Labels[Labels.length - 1].id;
    // }
  }
  UNSAFE_componentWillMount() {
     
    this.eventId = this.props.userEventDetails.eventDetailsInfo.eventId;
    this.profileId = this.props.user.data.result.profileId;
    this.eventType = this.props.userEventDetails.eventDetailsInfo.eventType;

    let adminDetails = '';
    if (this.props.celebrityInfo) {
      adminDetails = this.props.celebrityInfo;
    }
    this.checkBoxSelected = adminDetails.hasPermission;
    this.setState({ permission: adminDetails.hasPermission });
    // if (adminDetails.email && this.props.celebrityInfo && this.props.celebrityInfo.iscoOwner === 'true') {
    //   this.checkBoxSelected = true;
    //   this.setState({
    //     permission: true,
    //   });
    // }
  }
  // confirmationAcceptedCB = () => {
  //   // this.email.setValue('');
  //   this.checkBoxSelected = false;
  //   if (document.querySelector('#email')) {
  //     document.querySelector('#email').value = '';
  //     this.formData.owner.ownerEmail = '';
  //     this.adminDetails.email = '';
  //   } else {
  //     this.formData.owner.ownerEmail = '';
  //     this.adminDetails.email = '';
  //   }
  //   this.setState({
  //     permission: false,
  //   });
  //   // this.state.permission = false;
  //   if (document.querySelector('.mailInput')) {
  //     document.querySelector('.mailInput').setAttribute('style', 'display:none');
  //   }
  // }
  confirmationAcceptedCB = () => {
    // this.email.setValue('');
    this.checkBoxSelected = false;
    // if (document.querySelector('#email')) {
    //   document.querySelector('#email').value = '';
    //   this.formData.owner.ownerEmail = '';
    //   this.adminDetails.email = '';
    // } else {
    //   this.formData.owner.ownerEmail = '';
    //   this.adminDetails.email = '';
    // }
    this.setState({
      permission: false,
    });
    // if (document.querySelector('.mailInput')) {
    //   document.querySelector('.mailInput').setAttribute('style', 'display:none');
    // }
  }
  confirmationRejectedCB = () => {
  }
  getSelectedValue = (data, showWarningPopUp) => {
    if (!data.checked && showWarningPopUp) {
      this.modal.handleShow();
    } else {
      this.checkBoxSelected = data.checked;
      this.setState({
        permission: data.checked,
      });
      if (data.checked) {
        if (channel === 'web') {
          document.querySelector('.mailInput').setAttribute('style', 'display:block');
          return;
        }
        if (document.querySelector('.adminMail')) {
          document.querySelector('.adminMail').setAttribute('style', 'display:block');
        }
        if (document.querySelector('.mailInput')) {
          document.querySelector('.mailInput').setAttribute('style', 'display:block');
        }
      }
      // if (channel === 'web') {
      //   document.querySelector('.mailInput').setAttribute('style', 'display:none');
      //   return;
      // }
      // if (document.querySelector('.adminMail')) {
      //   document.querySelector('.adminMail').setAttribute('style', 'display:none');
      // }
      // if (document.querySelector('.mailInput')) {
      //   document.querySelector('.mailInput').setAttribute('style', 'display:none');
      // }
    }
  }
  getSelectedValueWhileAddingCoOwner = (data) => {
    this.checkBoxSelected = data.checked;
    if (this.checkBoxSelected) {
      this.setState({
        permission: data.checked,
      });
    }

    if (data.checked) {
      if (channel === 'web') {
        document.querySelector('.mailInput').setAttribute('style', 'display:block');
        return;
      }
      if (document.querySelector('.adminMail')) {
        document.querySelector('.adminMail').setAttribute('style', 'display:block');
      }
      if (document.querySelector('.mailInput')) {
        document.querySelector('.mailInput').setAttribute('style', 'display:block');
      }
    } else {
      if (channel === 'web') {
        document.querySelector('.mailInput').setAttribute('style', 'display:none');
        return;
      }
      if (document.querySelector('.adminMail')) {
        document.querySelector('.adminMail').setAttribute('style', 'display:none');
      }
      if (document.querySelector('.mailInput')) {
        document.querySelector('.mailInput').setAttribute('style', 'display:none');
      }
    }
  }
  validate = () => {

    if(channel !='web'){
        if(this.selectedDate && this.selectedDate.state.date===""){
            if(this.props.celebrityInfo && this.props.celebrityInfo.dateOfBirth) {
                this.selectedDate.state.date = this.props.celebrityInfo.dateOfBirth
            }
        }
    }
    let dataGotChanged = true;
    this.formData.owner.ownerfirstName = this.firstName.getValue();
    this.formData.owner.ownerlastName = this.lastName.getValue();
    this.formData.owner.ownerMotherName = this.motherName.getValue();
    this.formData.owner.ownerNickName = this.nickName.getValue();
    this.formData.owner.ownerPhone = this.phone.getValue();
    this.formData.owner.ownerEmail = this.email ? this.email.getValue().toLowerCase() : '';
    this.formData.owner.ownerDateofbirth = this.selectedDate.state.date;
    const warningRef = this.warning;
    this.formData.owner.ownerHasPermission = this.state.permission;

    const index = this.titles.indexOf(this.formData.owner.ownerTitle);
    this.formData.owner.ownerLabel = this.labels[index];

    if (this.props.userEventDetails && this.props.userEventDetails.eventDetailsInfo && this.props.userEventDetails.eventDetailsInfo.celebrityInfo && this.adminDetails && this.adminDetails.repositoryId) {
      const ownerTempData = this.adminDetails ? this.adminDetails : null;
      this.props.userEventDetails.eventDetailsInfo.celebrityInfo.map((data) => {
        if (data && data.repositoryId && ownerTempData && ownerTempData.repositoryId && data.repositoryId === ownerTempData.repositoryId) {
          if (JSON.stringify(data) === JSON.stringify(ownerTempData)) {
            dataGotChanged = false;
          }
        }
        return dataGotChanged;
      });
    }

    const firstNameValidationRules = [
      { functionRef: this.isValueAvailable, funcData: [this.firstName.getValue()], errorMessage: commonUtil.getError(errorObject.DatosDeMiEvento, 'DatosDeMiEvento.firstName.error.required') },
      { functionRef: commonUtil.validateName, funcData: [this.firstName.getValue(), 1, true], errorMessage: commonUtil.getError(errorObject.CreateEventStep1, 'CreateEventStep1.error.invalid') },

    ];
    const firstNameValid = commonUtil.validateTextInput(firstNameValidationRules, this.firstName, null);
    if (firstNameValid) {
      this.formData.owner.ownerfirstName = this.firstName.getValue();
    }

    const lastNameValidationRules = [
      { functionRef: this.isValueAvailable, funcData: [this.lastName.getValue()], errorMessage: commonUtil.getError(errorObject.DatosDeMiEvento, 'DatosDeMiEvento.lastName.error.required') },
      { functionRef: commonUtil.validateName, funcData: [this.lastName.getValue(), 1, true], errorMessage: commonUtil.getError(errorObject.CreateEventStep1, 'CreateEventStep1.error.invalid') },

    ];
    const lastNameValid = commonUtil.validateTextInput(lastNameValidationRules, this.lastName, null);
    if (lastNameValid) {
      this.formData.owner.ownerlastName = this.lastName.getValue();
    }

    let motherValidName = true;
    const motherNameValidation = [
      { functionRef: commonUtil.validateLength, funcData: [this.motherName.getValue(), 1], errorMessage: commonUtil.getError(errorObject.DatosDeMiEvento, 'DatosDeMiEvento.motherName.error.required') },
      { functionRef: commonUtil.validateName, funcData: [this.motherName.getValue(), 1, true], errorMessage: commonUtil.getError(errorObject.CreateEventStep1, 'CreateEventStep1.error.invalid') },

    ];
    motherValidName = commonUtil.validateTextInput(motherNameValidation, this.motherName, null);
    if (motherValidName) {
      this.formData.owner.ownerMotherName = this.motherName.getValue();
    }
    let birthDateValid = true;
   
    const birthDateValidationRules = {
        functionRef: commonUtil.isValueAvailable, funcData: [this.selectedDate.state.date], errorMessage: commonUtil.getError(errorObject.CreateEventStep1, 'CreateEventStep1.error.required')
    };
    birthDateValid = commonUtil.validateCalendarInput(birthDateValidationRules, this.selectedDate, null);

    let aliasValidName = true;
    if (this.formData.owner.ownerNickName) {
      const aliasNameValidation = [
        { functionRef: commonUtil.validateLength, funcData: [this.nickName.getValue(), 1], errorMessage: commonUtil.getError(errorObject.DatosDeMiEvento, 'DatosDeMiEvento.nickName.error.required') },
        { functionRef: commonUtil.validateName, funcData: [this.nickName.getValue(), 1, true], errorMessage: commonUtil.getError(errorObject.CreateEventStep1, 'CreateEventStep1.error.invalid') },

      ];
      aliasValidName = commonUtil.validateTextInput(aliasNameValidation, this.nickName, null);
      if (aliasValidName) {
        this.formData.owner.ownerNickName = this.nickName.getValue();
      }
    }

    let phoneNumberValid = true;
    if (this.formData.owner.ownerPhone) {
      const phoneNumberValidationRules = [
        // { functionRef: this.isPhoneNumberValidInLength, funcData: [this.phone.getValue()], errorMessage: 'El número de teléfono no es válido' },
        { functionRef: commonUtil.validateNumber, funcData: [this.phone.getValue()], errorMessage: commonUtil.getError(errorObject.CreateEventStep1, 'CreateEventStep1.error.invalid') },
      ];
      phoneNumberValid = commonUtil.validateTextInput(phoneNumberValidationRules, this.phone, null);
      if (phoneNumberValid) {
        this.formData.owner.ownerPhone = this.phone.getValue();
      }
    }

    const emailId = this.formData.owner.ownerEmail;
    let emailValid = true;
    if (this.email) {
      const emailValidationRules = [
        { functionRef: commonUtil.compareEmail, funcData: [this.email.getValue(), this.ownerEmailId], errorMessage: commonUtil.getError(errorObject.CreateEventStep1, 'CreateEventStep1.emailMatch.error') },
        { functionRef: this.isValueAvailable, funcData: [this.email.getValue()], errorMessage: commonUtil.getError(errorObject.DatosDeMiEvento, 'DatosDeMiEvento.email.error.required') },
        { functionRef: commonUtil.validateEmail, funcData: [this.email.getValue(), 3], errorMessage: commonUtil.getError(errorObject.DatosDeMiEvento, 'DatosDeMiEvento.email.error.invalid') },
      ];
      emailValid = commonUtil.validateTextInput(emailValidationRules, this.email, null);
      if (emailValid) {
        this.formData.owner.ownerEmail = this.email.getValue().toLowerCase();
      } else {
        this.formData.owner.ownerEmail = ' ';
      }
    }

    let titleValid = true;
    if (this.selectedEventConfiguration.selectionEnable === true && this.editOwner === false) {
      const titleValidValidationConfig = {
        functionRef: commonUtil.validateSelectedValue, funcData: [this.title.getSelectedIndex()], errorMessage: commonUtil.getError(errorObject.DatosDeMiEvento, 'DatosDeMiEvento.role.error.required'),
      };
      titleValid = commonUtil.validateSelecteTab(titleValidValidationConfig, this.title, null);
    }


    if (this.checkBoxSelected && emailId && this.editOwner === false) {
      isCoOwnerEligible(emailId, this.eventType).then((response) => {
        getCoOwnerProfileId(emailId).then((respo) => {
          if (response.body.status.status !== defaultConst.constAPISuccess) {
            warningRef.setMessage(response.body.status.errorMessage);
          } else if (firstNameValid && lastNameValid && motherValidName && birthDateValid && aliasValidName && phoneNumberValid && emailValid && titleValid) {
            const profileId = !respo.body.status.errorMessage ? respo.body.profileId : null;
            addCoOwnerDetails(this.formData.owner, this.eventId, profileId).then((res) => {
              if (res.body.status.status === defaultConst.constAPISuccess) {
                this.props.getEventDetails(this.eventId, this.profileId);
                if (this.props.hideCelebityEditingSection) {
                  this.props.hideCelebityEditingSection();
                }
                this.props._newCoOwnerAddedResponseCallback(response.body.status.status);
              } else {
                warningRef.setMessage(res.body.status.errorMessage);
              }
            }).catch((e) => { console.log(e); }); // console required
          }
        });
      });
    } else if (firstNameValid && lastNameValid && motherValidName && birthDateValid && aliasValidName && phoneNumberValid && titleValid && !this.checkBoxSelected && this.editOwner === false) {
      addCoOwnerDetails(this.formData.owner, this.eventId).then((res) => {
        if (res.body.status.status === defaultConst.constAPISuccess) {
          this.props.getEventDetails(this.eventId, this.profileId);
          if (this.props.hideCelebityEditingSection) {
            this.props.hideCelebityEditingSection();
          }
          this.props._newCoOwnerAddedResponseCallback(res.body.status.status);
        }
      }).catch((e) => { console.log(e); }); // console required
    }

    // if (!this.editOwner) {
    //   const motherNameValid = commonUtil.validateTextInput(motherNameValidationRules, this.motherName, null);
    //   const aliasNameValid = commonUtil.validateTextInput(aliasNameValidationRules, this.nickName, null);

    //   if (motherNameValid) {
    //     this.formData.owner.motherName = this.motherName.getValue();
    //   }
    //   if (aliasNameValid) {
    //     this.formData.owner.nickName = this.nickName.getValue();
    //   }
    // }

    if (this.editOwner) {
      // const eventId = this.props.userEventDetails.eventDetailsInfo.eventId;
      this.formData.owner.ownerId = this.adminDetails.repositoryId;
      this.formData.owner.ownerHasPermission = this.state.permission;

      // *Note : below code has been commented because in case of editing blank is also allowed
      // this.formData.owner.ownerMotherName = this.motherName.getValue() !== '' ? this.motherName.getValue() : this.adminDetails.motherName;
      // this.formData.owner.ownerNickName = this.nickName.getValue() !== '' ? this.nickName.getValue() : this.adminDetails.nickName;
      //   this.formData.owner.ownerPhone = this.phone.getValue() !== '' ? this.phone.getValue() : this.adminDetails.phone;
      this.formData.owner.ownerPhone = this.phone.getValue();
      this.formData.owner.ownerMotherName = this.motherName.getValue();
      this.formData.owner.ownerNickName = this.nickName.getValue();
      this.formData.owner.ownerEmail = this.email && this.email.getValue() !== '' ? this.email.getValue().toLowerCase() : this.adminDetails.email;
      this.formData.owner.iscoOwner = this.adminDetails.iscoOwner;

      // temp code for coowner permission remoe scenario.
      this.coOwnerPermission = this.state.permission;
      if (this.coOwnerPermission === false) {
        dataGotChanged = true;
      }
      // ///////////////////////////////////////////

      if (this.adminDetails.iscoOwner === 'false') {
        this.formData.owner.profileId = this.props.user.data.result.profileId;
      }
      if (this.props.selectedEventConfiguration.selectionEnable === false) {
        this.formData.owner.ownerTitle = 'Mr';
      } else {
        this.formData.owner.ownerTitle = this.adminDetails.title;
      }
      if (this.checkBoxSelected) {
        dataGotChanged = true;
        if (emailId && emailId !== this.props.celebrityInfo.email) {
          isCoOwnerEligible(emailId, this.eventType).then((response) => {
            if (this.props.userEventDetails && this.props.userEventDetails.eventDetailsInfo && this.props.userEventDetails.eventDetailsInfo.celebrityInfo &&
              this.formData && this.formData.owner && this.formData.owner.ownerId) {
              const ownerTempData = this.formData && this.formData.owner ? this.formData.owner : null;
              this.props.userEventDetails.eventDetailsInfo.celebrityInfo.map((data) => {
                if (data && data.repositoryId && ownerTempData && ownerTempData.ownerId && data.repositoryId === ownerTempData.ownerId) {
                  if (JSON.stringify(data) === JSON.stringify(ownerTempData)) {
                    dataGotChanged = false;
                  }
                }
                return dataGotChanged;
              });
            }
            if (response.body.status.status !== defaultConst.constAPISuccess) {
              warningRef.setMessage(response.body.status.errorMessage);
              document.querySelector('.alertError').scrollIntoView();
            } else if (motherValidName && birthDateValid  && aliasValidName && emailValid && phoneNumberValid && dataGotChanged) {
              getCoOwnerProfileId(emailId).then((respo) => {
                const profileId = !respo.body.status.errorMessage ? respo.body.profileId : null;
                updateOwnerDetails(this.formData.owner, profileId).then((res) => {
                  if (res.body.status.status === defaultConst.constAPISuccess) {
                    if (this.props.hideCelebityEditingSection) {
                      this.props.hideCelebityEditingSection();
                    }
                    this.props.getEventDetails(this.eventId, this.profileId);
                    if (this.props._eventUpdateResponseCallback) {
                      this.props._eventUpdateResponseCallback(response.body.status.status);
                    }
                  }
                }).catch((e) => {
                  console.log(e); // console required
                });
              }).catch((e) => {
                console.log(e); // console required
              });
            }
          });
        } else {
          if (this.props.userEventDetails && this.props.userEventDetails.eventDetailsInfo && this.props.userEventDetails.eventDetailsInfo.celebrityInfo &&
            this.formData && this.formData.owner && this.formData.owner.ownerId) {
            const ownerTempData = this.formData && this.formData.owner ? this.formData.owner : null;
            this.props.userEventDetails.eventDetailsInfo.celebrityInfo.map((data) => {
              if (data && data.repositoryId && ownerTempData && ownerTempData.ownerId && data.repositoryId === ownerTempData.ownerId) {
                if (JSON.stringify(data) === JSON.stringify(ownerTempData)) {
                  dataGotChanged = false;
                }
              }
              return dataGotChanged;
            });
          }
          if (motherValidName && birthDateValid  && aliasValidName && emailValid && phoneNumberValid && dataGotChanged) {
            // const profileId = this.props.celebrityInfo.profileId ? this.props.celebrityInfo.profileId : '';
            updateOwnerDetails(this.formData.owner).then((res) => {
              if (res.body.status.status === defaultConst.constAPISuccess) {
                if (this.props.hideCelebityEditingSection) {
                  this.props.hideCelebityEditingSection();
                }
                this.props.getEventDetails(this.eventId, this.profileId);
                if (this.props._eventUpdateResponseCallback) {
                  this.props._eventUpdateResponseCallback(res.body.status.status);
                }
              }
            }).catch((e) => {
              console.log(e); // console required
            });
          }
        }
      } else if (motherValidName && birthDateValid  && aliasValidName && emailValid && phoneNumberValid && dataGotChanged) {
        updateOwnerDetails(this.formData.owner).then((response) => {
          if (response.body.status.status === defaultConst.constAPISuccess) {
            if (this.props.hideCelebityEditingSection) {
              this.props.hideCelebityEditingSection();
            }
            this.props.getEventDetails(this.eventId, this.profileId);
            if (this.props._eventUpdateResponseCallback) {
              this.props._eventUpdateResponseCallback(response.body.status.status);
            }
          }
        }).catch((e) => {
          console.log(e); // console required
        });
      } else if (!dataGotChanged) {
        if (this.props.hideCelebityEditingSection) {
          this.props.hideCelebityEditingSection();
        } else {
          this.props._eventUpdateResponseCallback(defaultConst.constAPISuccess);
        }
      }
    }
  }

  handleAllowOnlyDigit = (e) => {
    const ctl = e.target.id;
    const limitLength = e.target.maxLength;
    const thisObj = document.querySelector('#' + ctl);
    const keyCode = e.keyCode;
    // backspace, delete, left arrow and right arrow
    if (keyCode === 46 || keyCode === 8 || keyCode === 9 || keyCode === 37 || keyCode === 39) {
      return true;
    }
    if ((keyCode >= 48 && keyCode <= 57) || (keyCode >= 96 && keyCode <= 105)) {
      // numbers and numeric keypad
      if (thisObj.value.length > limitLength) {
        e.preventDefault();
        e.stopPropagation();
      }
    } else {
      e.preventDefault();
      e.stopPropagation();
    }
    return true;
  }
  sendEmail = () => {
    const warningRef = this.warning;
    if (this.adminDetails.iscoOwner === 'true') {
      const email = this.adminDetails.email;
      sendEmailToCoOwner(this.eventId, email).then((response) => {
        if (response.body.status !== defaultConst.constAPISuccess) {
          warningRef.setMessage(response.body.status.errorMessage);
        } else {
          document.querySelector('.notClicked').setAttribute('style', 'display:none');
          document.querySelector('.clicked').setAttribute('style', 'display:block');
          if (document.querySelector('.icon-check')) {
            document.querySelector('.icon-check').setAttribute('style', 'display:block');
          }
        }
      });
    }
  }

  // setter function while editing.
  setNewAdminDeatils = (fieldName, value) => {
    if (fieldName === 'motherName') {
      this.adminDetails.motherName = value;
    }
    if (fieldName === 'nickName') {
      this.adminDetails.nickName = value;
    }
    if (fieldName === 'celular') {
      this.adminDetails.phone = value;
    }
  }
  // getEmailTextBoxAndPermissionBox = (loggedInUserType, isCoOwner, editOwner, email, displayEmail, lables, hasPermission) => {
  //   const sendEmailLink = {
  //     children: commonUtil.getLabel(lables.editEvent, 'editevent.email.resend.label'),
  //     href: 'javascript:void(0)',
  //     cssClass: 'notClicked',
  //     onClickHandler: this.sendEmail,
  //   };

  //   let type = '';
  //   // below conditon is used when email feild already present and displayEmailField is true(it show checkBox checked & email feild with pre populated value)
  //   if (loggedInUserType === 'Owner' && isCoOwner === 'true' && editOwner && email && displayEmail === 'true') {
  //     type = 'HAS_EMAIL_AND_DISPLAY_TRUE';
  //   }
  //   // below conditon is used when email feild already present and displayEmailField is false(it show checked checkBox)
  //   if (loggedInUserType === 'Owner' && isCoOwner === 'true' && editOwner && email && displayEmail === 'false') {
  //     type = 'HAS_EMAIL_AND_DISPLAY_FALSE';
  //   }
  //   // below conditon will only work when owner didn't give permission while adding coOwner, this will give checkBox to give permission
  //   if (loggedInUserType === 'Owner' && isCoOwner === 'true' && editOwner && !email && displayEmail === 'true') {
  //     type = 'DONT_HAVE_EMAIL_AND_DISPLAY_FALSE';
  //   }
  //   // below conditon is used when email feild already present and displayEmailField is true but permission is false
  //   // if (loggedInUserType === 'Owner' && isCoOwner === 'true' && editOwner && email && displayEmail === 'true' && hasPermission === false) {
  //   //   type = 'HAS_EMAIL_AND_PERMISSION_FALSE';
  //   // }
  //   if (loggedInUserType === 'Owner' && isCoOwner === 'false' && editOwner) {
  //     type = 'ITS_OWNER';
  //   }
  //   switch (type) {
  //     case 'HAS_EMAIL_AND_DISPLAY_TRUE':
  //       return (
  //         <div>{this.selectedEventConfiguration.permissionCheckBox ?
  //           <div className="changePermission allowAdmin">
  //             <CheckBox
  //               id="permission1"
  //               checked={this.state.permission}
  //               ref={el => (this.CheckBox = el)}
  //               getSelectedValue={e => this.getSelectedValue(e, 'showWarningPopUp')}
  //               displayName={commonUtil.getLabel(lables.editEvent, 'editevent.allow.access.gift')}
  //             >
  //               {channel === 'web' ?
  //                 <div className="tooltip-container inline-block">
  //                   <img src={commonUtil.getAssetURL() + '/images/helpIcon.png'} alt="Ayuda" id="link" className="img-responsive editOwnerWap tooltip-container" onMouseEnter={this.showPopOverMoreInfo} onMouseLeave={this.hidePopOverMoreInfo} onClick={this.showPopOverMoreInfo} />
  //                   <div className="arrow arrowMobile" />
  //                   <div className="tooltip-box">
  //                     <ul>{commonUtil.getLabel(lables.editEvent, 'eventManagement.permissionCheckbox.message')}</ul></div>
  //                 </div>
  //                 :
  //                 null
  //               }

  //             </CheckBox>
  //             <div className="mailInput adminMail">
  //               <p>{commonUtil.getLabel(lables.editEvent, 'editevent.email.notification.message')}</p>
  //               {this.state.permission &&
  //                 <div className="formBlock">
  //                   <TextInput
  //                     className="inputMaterial"
  //                     labelClassName="placeHolderMaterial"
  //                     htmlId="email"
  //                     label="Correo electrónico"
  //                     name="Correo electrónico"
  //                     maxlength="100"
  //                     value={this.adminDetails.email}
  //                     required="true"
  //                     star="*"
  //                     ref={el => (this.email = el)}
  //                   />
  //                 </div>}
  //               {this.adminDetails.email && channel === 'web' ?
  //                 <div className="resend">
  //                   <Link linkJSON={sendEmailLink}>{sendEmailLink.children}</Link>
  //                   <a className="clicked" href="javascript:void(0)" style={{ display: 'none' }}>{commonUtil.getLabel(lables.editEvent, 'editevent.email.resend.message')}</a>
  //                   <i className="icon-check" />
  //                 </div> : null
  //               }
  //               {this.adminDetails.email && channel === 'wap' ?
  //                 <div className="adminMail" style={{ display: 'block' }}>
  //                   <Link linkJSON={sendEmailLink}>{sendEmailLink.children}</Link>
  //                   <a className="clicked" href="javascript:void(0)" style={{ display: 'none' }}>{commonUtil.getLabel(lables.editEvent, 'editevent.email.resend.message')}</a>
  //                 </div> : null
  //               }
  //             </div>
  //           </div> : null}
  //         </div>
  //       );

  //     case 'HAS_EMAIL_AND_DISPLAY_FALSE':
  //       return (
  //         <div className="allowAdmin">{this.selectedEventConfiguration.permissionCheckBox ?
  //           <CheckBox
  //             id="permission2"
  //             checked={this.state.permission}
  //             /* checked={hasPermission} */
  //             ref={el => (this.CheckBox = el)}
  //             getSelectedValue={e => this.getSelectedValue(e, 'showWarningPopUp')}
  //             displayName={commonUtil.getLabel(lables.editEvent, 'editevent.allow.access.gift')}
  //           >
  //             {/* <img src={commonUtil.getAssetURL() + '/images/helpIcon.png'} alt="Ayuda" id="link" className="img-responsive editOwnerWap" onMouseOver={this.showPopOverMoreInfo} onClick={this.showPopOverMoreInfo} onMouseLeave={this.hidePopOverMoreInfo} />
  //           <div className={channel === 'web' ? 'popover bottom' : 'popover top popMobile'}>
  //               <div className="arrow arrowMobile" />
  //               <div className="popover-content">
  //                 <ul>{commonUtil.getLabel(lables.editEvent, 'editevent.email.notification.message')}</ul></div>
  //             </div> */}
  //             {channel === 'web' ?
  //               <div className="tooltip-container inline-block">
  //                 <img src={commonUtil.getAssetURL() + '/images/helpIcon.png'} alt="Ayuda" id="link" className="img-responsive editOwnerWap tooltip-container" onMouseEnter={this.showPopOverMoreInfo} onMouseLeave={this.hidePopOverMoreInfo} onClick={this.showPopOverMoreInfo} />
  //                 <div className="arrow arrowMobile" />
  //                 <div className="tooltip-box">
  //                   <ul>{commonUtil.getLabel(lables.editEvent, 'eventManagement.permissionCheckbox.message')}</ul></div>
  //               </div>
  //               :
  //               null
  //             }
  //           </CheckBox>
  //           : null}
  //         </div>

  //       );

  //     case 'DONT_HAVE_EMAIL_AND_DISPLAY_FALSE':
  //       return (
  //         <div>{this.selectedEventConfiguration.permissionCheckBox ? <div className="changePermission">
  //           <div className="allowAdmin">
  //             <CheckBox
  //               id="permission3"
  //               checked={this.state.permission}
  //               /* checked={hasPermission} */
  //               ref={el => (this.CheckBox = el)}
  //               getSelectedValue={this.getSelectedValue}
  //               displayName={commonUtil.getLabel(lables.editEvent, 'editevent.allow.access.gift')}
  //             >
  //               {/* <img src={commonUtil.getAssetURL() + '/images/helpIcon.png'} alt="Ayuda" id="link" className="img-responsive editOwnerWap" onClick={this.showPopOverMoreInfo} onMouseOver={this.showPopOverMoreInfo} onMouseLeave={this.hidePopOverMoreInfo} />
  //               <div className="popover bottom">
  //                 <div className="arrow arrowMobile" />
  //                 <div className="popover-content">
  //                   <ul>{commonUtil.getLabel(lables.editEvent, 'editevent.email.notification.message')}</ul></div>
  //               </div> */}
  //               {channel === 'web' ?
  //                 <div className="tooltip-container inline-block">
  //                   <img src={commonUtil.getAssetURL() + '/images/helpIcon.png'} alt="Ayuda" id="link" className="img-responsive editOwnerWap tooltip-container" onMouseEnter={this.showPopOverMoreInfo} onMouseLeave={this.hidePopOverMoreInfo} onClick={this.showPopOverMoreInfo} />
  //                   <div className="arrow arrowMobile" />
  //                   <div className="tooltip-box">
  //                     <ul>{commonUtil.getLabel(lables.editEvent, 'eventManagement.permissionCheckbox.message')}</ul></div>
  //                 </div>
  //                 :
  //                 null
  //               }
  //             </CheckBox>
  //           </div>
  //           <div className="mailInput adminMail">
  //             {this.state.permission &&
  //               <React.Fragment>
  //                 <p className="mailinput-marg">{commonUtil.getLabel(lables.editEvent, 'editevent.email.notification.message')}</p>
  //                 <div className="formBlock">
  //                   <TextInput
  //                     className="inputMaterial"
  //                     labelClassName="placeHolderMaterial"
  //                     htmlId="email"
  //                     label="Correo electrónico"
  //                     name="Correo electrónico"
  //                     maxlength="100"
  //                     value={this.adminDetails.email}
  //                     required="true"
  //                     star="*"
  //                     ref={el => (this.email = el)}
  //                   />
  //                 </div>
  //               </React.Fragment>
  //             }
  //           </div>
  //         </div> : null}

  //         </div>
  //       );

  //     // case 'HAS_EMAIL_AND_PERMISSION_FALSE':
  //     //   return (
  //     //     <div>{this.selectedEventConfiguration.permissionCheckBox ? <div className="changePermission">
  //     //       <div className="allowAdmin">
  //     //         <CheckBox
  //     //           id="permission3"
  //     //           checked={this.state.permission}
  //     //           /* checked={hasPermission} */
  //     //           ref={el => (this.CheckBox = el)}
  //     //           getSelectedValue={this.getSelectedValue}
  //     //           displayName={commonUtil.getLabel(lables.editEvent, 'editevent.allow.access.gift')}
  //     //         >
  //     //           {/* <img src={commonUtil.getAssetURL() + '/images/helpIcon.png'} alt="Ayuda" id="link" className="img-responsive editOwnerWap" onClick={this.showPopOverMoreInfo} onMouseOver={this.showPopOverMoreInfo} onMouseLeave={this.hidePopOverMoreInfo} />
  //     //           <div className="popover bottom">
  //     //             <div className="arrow arrowMobile" />
  //     //             <div className="popover-content">
  //     //               <ul>{commonUtil.getLabel(lables.editEvent, 'editevent.email.notification.message')}</ul></div>
  //     //           </div> */}
  //     //           {channel === 'web' ?
  //     //             <div className="tooltip-container inline-block">
  //     //               <img src={commonUtil.getAssetURL() + '/images/helpIcon.png'} alt="Ayuda" id="link" className="img-responsive editOwnerWap tooltip-container" onMouseEnter={this.showPopOverMoreInfo} onMouseLeave={this.hidePopOverMoreInfo} onClick={this.showPopOverMoreInfo} />
  //     //               <div className="arrow arrowMobile" />
  //     //               <div className="tooltip-box">
  //     //                 <ul>{commonUtil.getLabel(lables.editEvent, 'eventManagement.permissionCheckbox.message')}</ul></div>
  //     //             </div>
  //     //             :
  //     //             null
  //     //           }
  //     //         </CheckBox>
  //     //       </div>
  //     //       <div className="mailInput adminMail">
  //     //         {this.state.permission &&
  //     //           <React.Fragment>
  //     //             <p className="mailinput-marg">{commonUtil.getLabel(lables.editEvent, 'editevent.email.notification.message')}</p>
  //     //             <div className="formBlock">
  //     //               <TextInput
  //     //                 className="inputMaterial"
  //     //                 labelClassName="placeHolderMaterial"
  //     //                 htmlId="email"
  //     //                 label="Correo electrónico"
  //     //                 name="Correo electrónico"
  //     //                 maxlength="100"
  //     //                 value={this.adminDetails.email}
  //     //                 required="true"
  //     //                 star="*"
  //     //                 ref={el => (this.email = el)}
  //     //               />
  //     //             </div>
  //     //           </React.Fragment>
  //     //         }
  //     //       </div>
  //     //     </div> : null}

  //     //     </div>
  //     //   );

  //     case 'ITS_OWNER': return null;

  //     default: return null;
  //   }
  // }
  getEmailTextBoxAndPermissionBox = (loggedInUserType, isCoOwner, editOwner, email, displayEmail, lables, hasPermission) => {
    const sendEmailLink = {
      children: commonUtil.getLabel(lables.editEvent, 'editevent.email.resend.label'),
      href: 'javascript:void(0)',
      cssClass: 'notClicked',
      onClickHandler: this.sendEmail,
    };

    let type = '';
    // below conditon is used when email feild already present and displayEmailField is true(it show checked checkBox & email feild with pre populated value)
    if (loggedInUserType === 'Owner' && isCoOwner === 'true' && editOwner && email && displayEmail === 'true' && hasPermission === true) {
      type = 'HAS_EMAIL_AND_DISPLAY_TRUE';
    }
    // below conditon is used when email feild already present and displayEmailField is false(it show checked checkBox & email disable)
    if (loggedInUserType === 'Owner' && isCoOwner === 'true' && editOwner && email && displayEmail === 'false' && hasPermission === true) {
      type = 'HAS_EMAIL_AND_DISPLAY_FALSE';
    }
    // below conditon is used when email feild already present and displayEmailField is true but permission is false(it show unchecked checkBox & email on click)
    if (loggedInUserType === 'Owner' && isCoOwner === 'true' && editOwner && email && displayEmail === 'true' && hasPermission === false) {
      type = 'HAS_EMAIL_AND_DISPLAY_TRUE_PERMISSION_FALSE';
    }
    // below conditon will only work when owner didn't give permission while adding coOwner, this will give checkBox to give permission
    if (loggedInUserType === 'Owner' && isCoOwner === 'true' && editOwner && !email && displayEmail === 'true' && hasPermission === false) {
      type = 'DONT_HAVE_EMAIL_AND_DISPLAY_FALSE';
    }
    if (loggedInUserType === 'Owner' && isCoOwner === 'false' && editOwner) {
      type = 'ITS_OWNER';
    }
    switch (type) {
      case 'HAS_EMAIL_AND_DISPLAY_TRUE':
        return (
          <div>{this.selectedEventConfiguration.permissionCheckBox ?
            <div className="changePermission allowAdmin permissionBox">
              <CheckBox
                checked={this.state.permission}
                ref={el => (this.CheckBox = el)}
                getSelectedValue={e => this.getSelectedValue(e, 'showWarningPopUp')}
                displayName={commonUtil.getLabel(lables.editEvent, 'editevent.allow.access.gift')}
              >
                {channel === 'web' ?
                  <React.Fragment>
                    <img src={commonUtil.getAssetURL() + '/images/helpIcon.png'} alt="Ayuda" id="link" className="img-responsive editOwnerWap" onClick={this.showPopOverMoreInfo} onMouseOver={this.showPopOverMoreInfo} onMouseLeave={this.hidePopOverMoreInfo} />
                    {/* <div className={channel === 'web' ? 'popover bottom' : 'popover top popMobile'}>  */}
                    <div className="popover bottom">
                      <div className="arrow" />
                      <div className="popover-content">
                        <p dangerouslySetInnerHTML={{ __html: commonUtil.getLabel(lables.editEvent, 'editevent.email.notification.tooltip') }} />
                      </div>
                    </div>
                  </React.Fragment>
                  : null
                }
              </CheckBox>
              <div className="mailInput adminMail" style={{ display: 'block' }}>
                {/* <p>{commonUtil.getLabel(lables.editEvent, 'editevent.email.notification.message')}</p> */}
                <p dangerouslySetInnerHTML={{ __html: commonUtil.getLabel(lables.editEvent, 'editevent.email.notification.message') }} />
                <div className="formBlock">
                  <TextInput
                    className="inputMaterial"
                    labelClassName="placeHolderMaterial"
                    htmlId="email"
                    label="Correo electrónico"
                    name="Correo electrónico"
                    maxlength="100"
                    value={this.adminDetails.email}
                    required="true"
                    star="*"
                    ref={el => (this.email = el)}
                  />
                </div>
                {this.adminDetails.email && channel === 'web' ? <div className="resend">
                  <Link linkJSON={sendEmailLink}>{sendEmailLink.children}</Link>
                  <a className="clicked" href="javascript:void(0)" style={{ display: 'none' }}>{commonUtil.getLabel(lables.editEvent, 'editevent.email.resend.message')}</a>
                  <i className="icon-check" />
                </div> : null
                }
                {this.adminDetails.email && channel === 'wap' ? <div className="adminMail" style={{ display: 'block' }}>
                  <Link linkJSON={sendEmailLink}>{sendEmailLink.children}</Link>
                  <a className="clicked" href="javascript:void(0)" style={{ display: 'none' }}>{commonUtil.getLabel(lables.editEvent, 'editevent.email.resend.message')}</a>
                </div> : null
                }
              </div>
            </div> : null}
          </div>
        );

      case 'HAS_EMAIL_AND_DISPLAY_FALSE':
        return (
          <div>{this.selectedEventConfiguration.permissionCheckBox ?
            <div className="changePermission allowAdmin permissionBox">
              <CheckBox
                id="permission2"
                checked={this.state.permission}
                ref={el => (this.CheckBox = el)}
                getSelectedValue={e => this.getSelectedValue(e, 'showWarningPopUp')}
                displayName={commonUtil.getLabel(lables.editEvent, 'editevent.allow.access.gift')}
              >
                {channel === 'web' ?
                  <React.Fragment>
                    <img src={commonUtil.getAssetURL() + '/images/helpIcon.png'} alt="Ayuda" id="link" className="img-responsive editOwnerWap" onClick={this.showPopOverMoreInfo} onMouseOver={this.showPopOverMoreInfo} onMouseLeave={this.hidePopOverMoreInfo} />
                    {/* <div className={channel === 'web' ? 'popover bottom' : 'popover top popMobile'}>  */}
                    <div className="popover bottom">
                      <div className="arrow" />
                      <div className="popover-content">
                        <p dangerouslySetInnerHTML={{ __html: commonUtil.getLabel(lables.editEvent, 'editevent.email.notification.tooltip') }} />
                      </div>
                    </div>
                  </React.Fragment>
                  : null
                }

              </CheckBox>
              <div className="mailInput adminMail" style={{ display: 'block' }}>
                <p dangerouslySetInnerHTML={{ __html: commonUtil.getLabel(lables.editEvent, 'editevent.email.notification.message') }} />
                <div className="formBlock">
                  <TextInput
                    className="inputMaterial"
                    labelClassName="placeHolderMaterial"
                    htmlId="email"
                    label="Correo electrónico"
                    name="Correo electrónico"
                    maxlength="100"
                    value={this.adminDetails.email}
                    required="true"
                    star="*"
                    ref={el => (this.email = el)}
                    disabled="disabled"
                  />
                </div>
              </div>
            </div> : null}
          </div>

        );

      case 'DONT_HAVE_EMAIL_AND_DISPLAY_FALSE':
        return (
          <div>{this.selectedEventConfiguration.permissionCheckBox ? <div className="changePermission">
            <div className="allowAdmin">
              <CheckBox
                id="permission3"
                checked={this.state.permission}
                ref={el => (this.CheckBox = el)}
                getSelectedValue={this.getSelectedValue}
                displayName={commonUtil.getLabel(lables.editEvent, 'editevent.allow.access.gift')}
              >
                {channel === 'web' ?
                  <React.Fragment>
                    <img src={commonUtil.getAssetURL() + '/images/helpIcon.png'} alt="Ayuda" id="link" className="img-responsive editOwnerWap" onClick={this.showPopOverMoreInfo} onMouseOver={this.showPopOverMoreInfo} onMouseLeave={this.hidePopOverMoreInfo} />
                    <div className="popover bottom">
                      <div className="arrow" />
                      <div className="popover-content">
                        <p dangerouslySetInnerHTML={{ __html: commonUtil.getLabel(lables.editEvent, 'editevent.email.notification.tooltip') }} />
                      </div>
                    </div>
                  </React.Fragment> :
                  null
                }
              </CheckBox>
            </div>
            <div className="mailInput adminMail">
              <React.Fragment>
                <p dangerouslySetInnerHTML={{ __html: commonUtil.getLabel(lables.editEvent, 'editevent.email.notification.message') }} />
                {this.state.permission &&
                  <div className="formBlock">
                    <TextInput
                      className="inputMaterial"
                      labelClassName="placeHolderMaterial"
                      htmlId="email"
                      label="Correo electrónico"
                      name="Correo electrónico"
                      maxlength="100"
                      value={this.adminDetails.email}
                      required="true"
                      star="*"
                      ref={el => (this.email = el)}
                    />
                  </div>}
              </React.Fragment>
            </div>
          </div> : null}

          </div>
        );


      case 'HAS_EMAIL_AND_DISPLAY_TRUE_PERMISSION_FALSE':
        return (
          <div>{this.selectedEventConfiguration.permissionCheckBox ? <div className="changePermission">
            <div className="allowAdmin">
              <CheckBox
                id="permission4"
                checked={this.state.permission}
                ref={el => (this.CheckBox = el)}
                getSelectedValue={this.getSelectedValue}
                displayName={commonUtil.getLabel(lables.editEvent, 'editevent.allow.access.gift')}
              >
                {channel === 'web' ?
                  <React.Fragment>
                    <img src={commonUtil.getAssetURL() + '/images/helpIcon.png'} alt="Ayuda" id="link" className="img-responsive editOwnerWap" onClick={this.showPopOverMoreInfo} onMouseOver={this.showPopOverMoreInfo} onMouseLeave={this.hidePopOverMoreInfo} />
                    <div className="popover bottom">
                      <div className="arrow arrowMobile" />
                      <div className="popover-content">
                        <p dangerouslySetInnerHTML={{ __html: commonUtil.getLabel(lables.editEvent, 'editevent.email.notification.tooltip') }} />
                      </div>
                    </div>
                  </React.Fragment> :
                  null
                }
              </CheckBox>
            </div>
            <div className="mailInput adminMail" style={{ display: 'block' }}>
              <React.Fragment>
                <p dangerouslySetInnerHTML={{ __html: commonUtil.getLabel(lables.editEvent, 'editevent.email.notification.message') }} />
                <div className="formBlock">
                  <TextInput
                    className="inputMaterial"
                    labelClassName="placeHolderMaterial"
                    htmlId="email"
                    label="Correo electrónico"
                    name="Correo electrónico"
                    maxlength="100"
                    value={this.adminDetails.email}
                    required="true"
                    star="*"
                    ref={el => (this.email = el)}
                  />
                </div>
              </React.Fragment>
            </div>
          </div> : null}
          </div>
        );


      case 'ITS_OWNER': return null;

      default: return null;
    }
  }
  showPopOverMoreInfo = () => {
    document.querySelector('.popover').classList.add('showPopOver');
  }
  hidePopOverMoreInfo = () => {
    document.querySelector('.popover').classList.remove('showPopOver');
  }
  cancelEditingWap = () => {
    this.warning.setMessage('');
    this.props.hideCelebityEditingSection();
  }
  render() {
    this.emailData = this.props.celebrityInfo.email ? this.props.celebrityInfo.email : '';
    this.coOwnerValue = this.props.celebrityInfo.iscoOwner ? this.props.celebrityInfo.iscoOwner : '';
    const loggedInUserType = this.props.userEventDetails.eventDetailsInfo.loggedInUserType;
    const displayEmailField = this.props.celebrityInfo.displayEmailField;
    this.selectedEventConfiguration = this.props.selectedEventConfiguration;
    this.hasPermission = this.props.celebrityInfo.hasPermission;

    /* eslint-disable */

    // logic for checking the event type for lables & titles
    let selectedEventTitleData = [];
    let selectedEventLabelData = [];
    const tempArray = this.props.eventCategoryInfo.forEach((eventCategory) => {
      if (eventCategory.name === this.props.userEventDetails.eventDetailsInfo.eventType) {
        selectedEventTitleData = eventCategory.titles;
        selectedEventLabelData = eventCategory.labels;
      }
      return [];
    });
    this.titles = selectedEventTitleData
    this.labels = selectedEventLabelData
    //for titles
    const Titles = [];
    selectedEventTitleData.forEach((e) => {
      const _selectedEventMasterData = {}
      _selectedEventMasterData.id = e
      _selectedEventMasterData.value = e
      _selectedEventMasterData.labelResourceId = e
      Titles.push(_selectedEventMasterData)
    })

    // for lables
    const Labels = [];
    selectedEventLabelData.forEach((e) => {
      const _selectedEventLabelData = {}
      _selectedEventLabelData.id = e
      _selectedEventLabelData.value = e
      _selectedEventLabelData.labelResourceId = e
      Labels.push(_selectedEventLabelData)
    })

    // for coOwner service call fetching owner Label
    // if (document.querySelector('#lableArea')) {
    //   const temp = document.querySelector('#lableArea').innerText;
    //   this.formData.owner.ownerLabel = temp;
    // } else {
    //   this.formData.owner.ownerLabel = Labels[Labels.length - 1].id;
    // }

    // if (this.props.celebrityInfo) {
    //   this.adminDetails = JSON.parse(JSON.stringify(this.props.celebrityInfo));
    // }

    if (this.props.celebrityInfo) {
      this.editOwner = true;
    } else {
      this.editOwner = false;
    }

    /* eslint-enable */
    const { lables } = this.props;

    // const imgWebLinkData = {
    //   linkClass: 'imagelink',
    //   imgClass: 'img-responsive',
    //   label: '',
    //   src: commonUtil.getAssetURL() + '/images/helpIcon.png',
    //   alt: 'Ayuda',
    //   href: 'javascript:void(0)',
    //   id: 'link',
    //   disabled: true,
    // };

    const saveButtonWAP = {
      type: 'button',
      name: 'Guardar',
      value: 'Guardar',
      disabled: false,
      autoFocus: false,
      style: 'btnPrimaryAction',
      onClickHandler: this.validate,
    };

    const cancelButton = {
      name: 'Cancelar',
      type: 'button',
      value: 'Cancelar',
      disabled: false,
      autoFocus: false,
      style: 'btnSecondaryAction',
      onClickHandler: this.cancelEditingAndAdding,
    };

    const saveButton = {
      name: 'Guardar',
      type: 'button',
      value: 'Guardar',
      disabled: false,
      autoFocus: false,
      style: 'btnPrimaryAction',
      onClickHandler: this.validate,
    };
    const CalenderButton = {
      textClassName: 'form-control',
      textLabelClassName: 'label_one',
      textHtmlId: 'id_one',
      textPlaceholder: commonUtil.getLabel(lables.createEventStep1, 'createEventStep1.dob.label'),
      textRequired: true,
    };

    const startDate = new Date('january 01, 1900');
    const currentDate = new Date();
    return (
      <div>
        {channel === 'web' ?
          <div>
            <ApplyCSS pageName={pageName} />
            <div className="col-lg-12 col-md-12">
              <Warning type="error" text={this.warningMessage} ref={warning => this.warning = warning} />
            </div>
            <div className="col-sm-12 myEventInfo noBorder">
              {this.editOwner ? <h1>Editar datos</h1> : <h1> Agregar administrador</h1>}

              <div className="editAdminInfo">
                <div className="row">
                  <div className="col-sm-6">
                    <p><span id="lableArea">{this.editOwner ? '' : Labels[Labels.length - 1].id}</span></p>
                  </div>
                  <div className="col-sm-6">
                    <h6 className="requiredInput"><sup>*</sup> Campos Obligatorios</h6>
                  </div>
                </div>
                <form>
                  {this.editOwner === false ?
                    <div className="formBlock">
                      <SelectionTab
                        classname="cSelect required"
                        id="user"
                        optionCaption="Selecciona una opción"
                        options={Titles}
                        disable={this.editOwner && 'disabled'}
                        value={this.editOwner && this.adminDetails.title}
                        optionText={'labelResourceId'}
                        optionValue={'id'}
                        ref={el => (this.title = el)}
                        handleSelectedOption={val => this.formData.owner.ownerTitle = val.id}
                      />
                    </div>
                    : null
                  }
                  {this.selectedEventConfiguration.selectionEnable && this.editOwner ?
                    <div className="formBlock">
                      <TextInput
                        className="inputMaterial"
                        labelClassName="placeHolderMaterial"
                        htmlId="Title"
                        label="Título"
                        name="Título"
                        value={this.adminDetails.title}
                        required="true"
                        disabled={this.editOwner && 'disabled'}
                        ref={el => (this.title = el)}
                      /> </div> : null}
                  <div className="formBlock">
                    <TextInput
                      className="inputMaterial"
                      labelClassName="placeHolderMaterial"
                      htmlId="nombre"
                      label="Nombre"
                      name="firstname"
                      value={this.adminDetails.firstName}
                      required="true"
                      maxlength="100"
                      star="*"
                      disabled={this.editOwner && 'disabled'}
                      ref={el => (this.firstName = el)}
                    />
                  </div>
                  <div className="formBlock">
                    <TextInput
                      className="inputMaterial"
                      labelClassName="placeHolderMaterial"
                      htmlId="apellidoPaterno"
                      label="Apellido Paterno"
                      name="Apellido Paterno"
                      value={this.adminDetails.lastName}
                      required="true"
                      maxlength="100"
                      star="*"
                      disabled={this.editOwner && 'disabled'}
                      ref={el => (this.lastName = el)}
                    />
                  </div>
                  <div className="formBlock">
                    <TextInput
                      className="inputMaterial"
                      labelClassName="placeHolderMaterial"
                      htmlId="apellidoMaterno"
                      label="Apellido Materno"
                      name="Apellido Materno"
                      maxlength="100"
                      value={this.adminDetails.motherName}
                      onBlur={e => this.setNewAdminDeatils('motherName', e.target.value)}
                      required="true"
                      star="*"
                      disabled={this.adminDetails.motherName && 'disabled'}
                      ref={el => (this.motherName = el)}
                    />
                  </div>
                  <div className="formBlock">
                    <TextInput
                      className="inputMaterial"
                      labelClassName="placeHolderMaterial"
                      htmlId="alias"
                      label="Alias"
                      name="Alias"
                      maxlength="100"
                      onBlur={e => this.setNewAdminDeatils('nickName', e.target.value)}
                      value={this.adminDetails.nickName}
                      required="true"
                      star=""
                      disabled=""
                      ref={el => (this.nickName = el)}
                    />
                  </div>
                  <div className="inputBlock">
                    <div className="input-group date" id="datetimepicker1">
                      <CalenderSample
                        onChangeHandler={this.setDateOfBirth}
                        value={this.state.date ? this.state.date : this.adminDetails.dateOfBirth}
                        textInputJSON={CalenderButton}
                        ref={el => (this.selectedDate = el)}
                        minDate={startDate}
                        maxDate={currentDate}
                        activeStartDate={currentDate}
                        viewType="decade"
                      />
                    </div>
                  </div>
                  <div className="formBlock">
                    <TextInput
                      className="inputMaterial"
                      labelClassName="placeHolderMaterial"
                      htmlId="celular"
                      label="Celular"
                      name="celular"
                      maxlength="10"
                      value={this.adminDetails.phone}
                      onBlur={e => this.setNewAdminDeatils('celular', e.target.value)}
                      required="true"
                      ref={el => (this.phone = el)}
                      onKeyDown={(e) => { this.handleAllowOnlyDigit(e); }}
                    />
                  </div>

                  {/* below condition is used for show permission checkbox & email feild only in case of adding new co-owner */}
                  {loggedInUserType === 'Owner' && this.editOwner === false ?
                    <div className="changePermission">
                      <CheckBox
                        id="permission4"
                        /* checked={this.state.permission} */
                        checked={this.hasPermission}
                        ref={el => (this.CheckBox = el)}
                        getSelectedValue={this.getSelectedValueWhileAddingCoOwner}
                        displayName={commonUtil.getLabel(lables.editEvent, 'editevent.allow.access.gift')}
                      >
                        {/* <div className="tooltip-container inline-block">
                          <img src={commonUtil.getAssetURL() + '/images/helpIcon.png'} alt="Ayuda" id="link" className="img-responsive tooltip-container" onMouseEnter={this.showPopOverMoreInfo} onMouseLeave={this.hidePopOverMoreInfo} onClick={this.showPopOverMoreInfo} />
                          <div className="arrow arrowMobile" />
                          <div className="tooltip-box">
                            <ul>{commonUtil.getLabel(lables.editEvent, 'eventManagement.permissionCheckbox.message')}</ul></div>
                        </div> */}
                        <img src={commonUtil.getAssetURL() + '/images/helpIcon.png'} alt="Ayuda" id="link" className="img-responsive editOwnerWap" onClick={this.showPopOverMoreInfo} onMouseOver={this.showPopOverMoreInfo} onMouseLeave={this.hidePopOverMoreInfo} />
                        <div className="popover bottom">
                          <div className="arrow" />
                          <div className="popover-content">
                            <p dangerouslySetInnerHTML={{ __html: commonUtil.getLabel(lables.editEvent, 'editevent.email.notification.tooltip') }} />
                          </div>
                        </div>
                      </CheckBox>

                      <div className="mailInput">
                        <p dangerouslySetInnerHTML={{ __html: commonUtil.getLabel(lables.editEvent, 'editevent.email.notification.message') }} />
                        {/* {this.state.permission && */}
                        <div className="formBlock">
                          <TextInput
                            className="inputMaterial"
                            labelClassName="placeHolderMaterial"
                            htmlId="email"
                            label="Correo electrónico"
                            name="Correo electrónico"
                            maxlength="100"
                            value={this.adminDetails.email}
                            required="true"
                            star="*"
                            ref={el => (this.email = el)}
                          />
                        </div>
                        {/* } */}
                      </div>

                    </div>
                    :
                    null
                  }

                  {/* below conditon is used when email feild already present and displayEmailField is false */}
                  {this.getEmailTextBoxAndPermissionBox(loggedInUserType, this.coOwnerValue, this.editOwner, this.emailData, displayEmailField, lables, this.hasPermission,
                  )}

                  <div className="formButtons">
                    <InputButton buttonAttr={cancelButton} />
                    <InputButton buttonAttr={saveButton} />
                  </div>
                </form>
              </div>
            </div>
          </div>
          :
          // WAP view
          <div>
            <ApplyCSS pageName={pageName} />
            <div className="modal fade in" id="editAdminCelebratedInfoModal" tabIndex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true" style={{ left: innerWidth, display: 'block' }}>
              <div className="modal-dialog modal-lg">
                <div className="modal-content">
                  <div className="modal-body" style={{ height: (window.innerHeight) + 'px' }}>
                    <div className="editAdminCelebratedInfo">
                      {this.props.isAddingNewCoOwnerMode &&
                        <React.Fragment>
                          <div className="row boxHeader row-box-marg">
                            <div className="col-xs-12 ">
                              {this.editOwner ? <h2>{commonUtil.getLabel(lables.editEvent, 'editEvent.edit.celebrity.title.wap')}</h2> : <h2> Agregar administrador</h2>}
                              <span className="close" onClick={this.hideCelebityEditingSection} >Cerrar <i className="icon-tache2" />
                              </span>
                            </div>
                          </div>
                          <div className="row boxContent">
                            <div className="col-xs-12" style={{ height: (window.innerHeight) + 'px' }}>
                              {/* <h2 className="margin-header"><span id="lableArea">{Labels[Labels.length - 1].id}</span></h2> */}
                              <div className="editAdminCelebratedInfo-required">
                                <p>* Campos obligatorios</p>
                              </div>
                              <form>
                                {this.editOwner === false ?
                                  <div className="formBlock">
                                    <SelectionTab
                                      classname="cSelect required"
                                      id="user"
                                      optionCaption="Selecciona una opción"
                                      options={Titles}
                                      disable={this.editOwner && 'disabled'}
                                      value={this.editOwner && this.adminDetails.title}
                                      optionText={'labelResourceId'}
                                      optionValue={'id'}
                                      ref={el => (this.title = el)}
                                      handleSelectedOption={val => this.formData.owner.ownerTitle = val.id}
                                    />
                                  </div>
                                  : null
                                }
                                {this.selectedEventConfiguration.selectionEnable && this.editOwner ? <TextInput
                                  className="inputMaterial "
                                  labelClassName="placeHolderMaterial"
                                  htmlId="Title"
                                  label="Título"
                                  name="Título"
                                  value={this.adminDetails.title}
                                  required="true"
                                  disabled={this.editOwner && 'disabled'}
                                  ref={el => (this.title = el)}
                                /> : null}

                                <div className="formBlock">
                                  <TextInput
                                    className="inputMaterial "
                                    labelClassName="placeHolderMaterial"
                                    htmlId="nombre"
                                    label="Nombre"
                                    name="firstname"
                                    value={this.adminDetails.firstName}
                                    required="true"
                                    maxlength="100"
                                    star="*"
                                    disabled={this.editOwner && 'disabled'}
                                    ref={el => (this.firstName = el)}
                                  />
                                </div>
                                <div className="formBlock">
                                  <TextInput
                                    className="inputMaterial "
                                    labelClassName="placeHolderMaterial"
                                    htmlId="apellidoPaterno"
                                    label="Apellido Paterno"
                                    name="Apellido Paterno"
                                    value={this.adminDetails.lastName}
                                    required="true"
                                    maxlength="100"
                                    star="*"
                                    disabled={this.editOwner && 'disabled'}
                                    ref={el => (this.lastName = el)}
                                  />
                                </div>
                                <div className="formBlock">
                                  <TextInput
                                    className="inputMaterial "
                                    labelClassName="placeHolderMaterial"
                                    htmlId="apellidoMaterno"
                                    label="Apellido Materno"
                                    name="Apellido Materno"
                                    maxlength="100"
                                    value={this.adminDetails.motherName}
                                    onBlur={e => this.setNewAdminDeatils('motherName', e.target.value)}
                                    required="true"
                                    star="*"
                                    disabled={this.adminDetails.motherName && 'disabled'}
                                    ref={el => (this.motherName = el)}
                                  />
                                </div>
                                <div className="formBlock">
                                  <TextInput
                                    className="inputMaterial "
                                    labelClassName="placeHolderMaterial"
                                    htmlId="alias"
                                    label="Alias"
                                    name="Alias"
                                    maxlength="100"
                                    value={this.adminDetails.nickName}
                                    onBlur={e => this.setNewAdminDeatils('nickName', e.target.value)}
                                    required="true"
                                    disabled=""
                                    ref={el => (this.nickName = el)}
                                  />
                                </div>
                                <div className="inputBlock">
                                  <div className="input-group date" id="datetimepicker1">
                                    <CalenderSample
                                      value={this.state.date ? this.state.date : this.adminDetails.dateOfBirth}
                                      textInputJSON={CalenderButton}
                                      onChangeHandler={this.setDateOfBirth}
                                      ref={el => (this.selectedDate = el)}
                                      minDate={startDate}
                                      maxDate={currentDate}
                                      activeStartDate={currentDate}
                                      viewType="decade"
                                    />
                                  </div>
                                </div>
                                <div className="formBlock">
                                  <TextInput
                                    className="inputMaterial "
                                    labelClassName="placeHolderMaterial"
                                    htmlId="celular"
                                    label="Celular"
                                    name="celular"
                                    type="tel"
                                    maxlength="10"
                                    value={this.adminDetails.phone}
                                    onBlur={e => this.setNewAdminDeatils('celular', e.target.value)}
                                    required="true"
                                    ref={el => (this.phone = el)}
                                    onKeyDown={(e) => { this.handleAllowOnlyDigit(e); }}
                                  />
                                </div>

                                {/* below condition is used for show permission checkbox & email feild only in case of adding new co-owner */}
                                {loggedInUserType === 'Owner' && this.editOwner === false ?
                                  <div>
                                    <div className="allowAdmin">
                                      <CheckBox
                                        id="permission5"
                                        /* checked={this.state.permission} */
                                        checked={this.hasPermission}
                                        ref={el => (this.CheckBox = el)}
                                        getSelectedValue={this.getSelectedValueWhileAddingCoOwner}
                                        displayName={commonUtil.getLabel(lables.editEvent, 'editevent.allow.access.gift')}
                                      />
                                    </div>

                                    <div className="adminMail" >
                                      <p dangerouslySetInnerHTML={{ __html: commonUtil.getLabel(lables.editEvent, 'editevent.email.notification.message') }} />
                                      {/* {this.state.permission && */}
                                      <div className="formBlock form-block-marg-one">
                                        <TextInput
                                          className="inputMaterial "
                                          labelClassName="placeHolderMaterial"
                                          htmlId="email"
                                          label="Correo electrónico"
                                          name="Correo electrónico"
                                          maxlength="100"
                                          value={this.adminDetails.email}
                                          required="true"
                                          star="*"
                                          ref={el => (this.email = el)}
                                        />
                                      </div>
                                      {/* } */}
                                    </div>
                                  </div>
                                  :
                                  null
                                }
                                <Warning type="error" text={this.warningMessage} ref={warning => this.warning = warning} />

                                {/* below conditon is used when email feild already present and displayEmailField is false */}
                                {this.getEmailTextBoxAndPermissionBox(loggedInUserType, this.coOwnerValue, this.editOwner, this.emailData, displayEmailField, lables, this.hasPermission,
                                )}

                                <div className="col-xs-12 formButtons form-buttons-marg mt0">
                                  <InputButton buttonAttr={saveButtonWAP} />
                                  {/* <InputButton buttonAttr={cancelButtonWAP} /> */}
                                  <a
                                    className="mediumLink"
                                    href="javascript:void(0)"
                                    onClick={() => { this.cancelEditingWap(); }}
                                  >Cancelar</a>
                                </div>
                              </form>
                            </div>
                          </div>
                        </React.Fragment>
                      }
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        }

        <ConfirmationModal
          lables={this.props.lables}
          ref={modal => this.modal = modal}
          confirmationAcceptedCB={this.confirmationAcceptedCB}
          confirmationRejectedCB={this.confirmationRejectedCB}
        />

      </div>
    );
  }
}

const mapStateToProps = state => ({
  lables: state.labels.data,
  user: state.user,
  userEventDetails: state.eventDetails.userEventDetails,
  eventCategoryInfo: state.eventcategory.data.eventConfigurations,
  // eventId: state.eventDetails.userEventDetails.eventDetailsInfo.eventId,
});

const matchDispatchToProps = dispatch => bindActionCreators({ addCoOwnerDetails }, dispatch);

export default connect(mapStateToProps, matchDispatchToProps, null, { forwardRef: true })(EditAdminCelebratedInfo);
// export default connect(mapStateToProps, matchDispatchToProps, null, { forwardRef: true })(EditForm);
